export default __webpack_public_path__ + "static/media/denim.d69098b4.png";